import { deleteKey } from '@/utils';

/**
 *
 * regista campo na store
 * @param {Object} field - { name: 'email', value: 'teste@teste.com' }
 *
 */
const REGISTER_FIELD = ( state, field ) => {
    state.payload = {
        ...state.payload,
        [field.name]: field.value
    };
};

/**
 *
 * apaga campo da store.
 * @param {Object} field - { name: 'email' }
 *
 */
const DELETE_FIELD = ( state, field ) => {
    const key = field.payloadKey || 'payload';
    state[key] = { ...deleteKey( field.name, state[key] ) };
};

/**
 *
 * Depois da submissão, limpa o payload.
 *
 */
const RESET_PAYLOAD = state => {
    state.payload = {};

    state.bar.active = false;
};

/**
 *
 * Accionado o trigger para fazer reset
 * ao valor das inputs.
 *
 *
 */
const RESET_MODEL = state => {
    state.reset = true;

    setTimeout( () => {
        state.reset = false;
    }, 300 );
};

/**
 *
 * Adicionado um helper de forma a
 * ser possível validar se alguma data é
 * valida para ser enviada para API.
 *
 *
 *
 */
const SAVE_HELPER = ( state, helper ) => {
    state.helpers = {
        ...state.helpers,
        ...helper
    };
};

/**
 *
 * Remoção dos helpers da store.
 *
 */
const RESET_HELPERS = state => {
    state.helpers = {};
};

/**
 *
 * gere o loading dos creates / updates feitos a API.
 * @param {Boolean} loading
 *
 */
const TOGGLE_LOADING = ( state, loading ) => {
    state.loading = loading;
};

/**
 *
 * gere os campos em falta na submissão de algum formulário.
 * @param {Object} fields - { email: true }
 *
 */
const MANAGE_MISSING_FIELDS = ( state, fields ) => {
    state.errors.missing = {
        ...fields
    };
};

/**
 *
 * Conforme o tipo de acção ( active / block ) irá
 * controlar a barra de acção.
 *
 * @param {Object} config
 * @param {String} config.type
 * @param {Boolean} config.value
 *
 */
const CONTROL_ACTION_BAR = ( state, config ) => {
    state.bar[config.type] = config.value;
};

/**
 *
 * Remoção do alerta de erros num determinado campo.
 *
 * @param {Object} payload
 * @param {String} payload.type - 'missing' || 'api'
 * @param {String} payload.fieldName
 *
 */
const RESET_ERROR = ( state, payload ) => {
    state.errors[payload.type] = { ...deleteKey( payload.fieldName, state.errors[payload.type] ) };
};

/**
 *
 * Remoção dos erros da store.
 *
 */
const RESET_ALL_ERRORS = state => {
    state.errors = {
        api: {},
        missing: {}
    };
};

/**
 *
 * Gestão da resposta proveniente da API.
 * Caso haja erros proveniente da API, é adicionado a store de erros.
 *
 *  @param {Object} response
 *  @param {String} response.type - 'success' || 'insuccess'
 *  @param {String} response.message
 *  @param {Array} response.errors - esta key só virá caso o status code seja 422.
 *
 */
const MANAGE_RESPONSE = ( state, response ) => {
    const { errors, ...responseWithoutErrors } = response;
    state.response = {
        ...responseWithoutErrors
    };

    state.bar.hide = true;
    if ( response.interrupt )
        state.bar.hide = false;
    else {
        setTimeout( () => {
            state.response = {
                ...{ has: false, message: '', type: '' }
            };

            state.update = false;
            state.bar.hide = false;
        }, 5000 );
    }

    if ( errors )
        state.errors.api = { ...errors };
};

/**
 *
 * Trigger para actualizar o modelo
 * após uma edição.
 *
 */
const UPDATE_MODEL = state => {
    state.update = true;
};

/**
 *
 * Após a criação de um bloco especifico de um modelo,
 * irá actualizar em tempo real esse mesmo bloco, de forma
 * a evitar um novo pedido a API.
 *
 *  @param {Object} block
 *
 */
const UPDATE_BLOCKS = ( state, block ) => {
    state.blocks = { ...block };

    // clear do block.
    setTimeout( () => {
        state.blocks = { ...{} };
    }, 3000 );
};

/**
 *
 * Após a submissão de um modelo para a API, pode
 * ser necessário executar um trigger na página.
 *
 *  @param {boolean} trigger
 *
 */
const TOGGLE_TRIGGER = ( state, trigger ) => {
    state.trigger = trigger;

    setTimeout( () => { state.trigger = false; }, 5000 );
};

/**
 *
 * Gravar os dados para pesquisa
 *
 *
 *
*/
const SAVE_SEARCH_DATA = ( state, searchData ) => {
    state.searchData = {
        ...state.searchData,
        ...searchData
    };
};

/**
 *
 * Remoção da pesquisa da store.
 *
 */
const RESET_SEARCH_DATA = state => {
    state.searchData = {};
};

export default {
    REGISTER_FIELD,
    DELETE_FIELD,
    RESET_PAYLOAD,
    RESET_MODEL,
    SAVE_HELPER,
    RESET_HELPERS,
    TOGGLE_LOADING,
    MANAGE_MISSING_FIELDS,
    CONTROL_ACTION_BAR,
    RESET_ERROR,
    RESET_ALL_ERRORS,
    MANAGE_RESPONSE,
    UPDATE_MODEL,
    UPDATE_BLOCKS,
    TOGGLE_TRIGGER,
    SAVE_SEARCH_DATA,
    RESET_SEARCH_DATA
};